import { jsx as t } from "react/jsx-runtime";
import n from "./stenn-logo-white.svg.mjs";
const g = (o) => /* @__PURE__ */ t("img", { ...o, alt: "Stenn logo", src: n });
export {
  g as StennLogoWhite
};
//# sourceMappingURL=StennLogoWhite.mjs.map
